import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const SpecialSession = () => {
  const show = true;
  if (show) {
  return (
    <React.Fragment>
      <SEO title="Special Sessions | DMBD 2025" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Special Sessions"
        content="For Authors"
        contentTwo="Special Sessions"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          {/* <h2 id="session1">SS1: Innovations in Big Data Processing and AI: Challenges, Architectures, and Applications</h2>
          <p className="home-p text-justify">

            Rapid advancements in big data and artificial intelligence technologies have had a profound impact
            on all areas of human society including the economy, management, politics, healthcare, and education.
            Big data analytics employs a variety of artificial intelligence techniques including machine learning,
            deep learning, computational optimization, evolutionary computation, and swarm intelligence.
            The special session aims at presenting the latest developments of the artificial intelligent algorithms
            in data mining, discussing the future direction of developments, and exchanging novel ideas about
            how to overcome the challenges.
            It welcomes the original contributions that provide novel theories, frameworks and applications to algorithms.
            <br></br>
            <h4>Topics of Interest</h4>
            Topics of interest include, but are not limited to:
            <ul>
            <li>Advanced Techniques for Big Data Analytics</li>
            <li>Deep Learning Architectures for Big Data</li>
            <li>Privacy and Security in Large-Scale Data Processing</li>
            <li>Online and Adaptive Learning for Streaming Data</li>
            <li>Generative Models and Large-Scale AI Systems</li>
            <li>Utilizing large-scale generative models for diverse applications.</li>
            <li>The role of generative adversarial networks (GANs) in Big Data and AI research.</li>
            <li>Clustering, Classification, and Prediction in Big Data</li>
            <li>Predictive analytics and its impact on decision-making across various domains.</li>
            <li>Big Data Architectures and System Design</li>
            <li>Tools and technologies for improving the quality of service (QoS) in Big Data processing.</li>
            <li>Applications of Big Data and AI in Emerging Technologies</li>
            <li>Case studies showcasing the impact of Big Data analytics on emerging technologies.</li>
            </ul>

            <h4>Submission</h4>
            Please follow the DMBD&apos;2024 instruction for authors and submit your paper via the DMBD&apos;2024
            online submission system. Please specify that your paper is for &quot; SS1--Innovations in Big Data Processing and AI: Challenges, Architectures, and Applications &quot; in your paper.
          </p>

          <h4>Organizers</h4>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Affiliate</th>
                <th scope="col">Email</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="align-middle">Prof. Arun Sharma</td>
                <td className="align-middle">Information Technology Indira Gandhi Delhi Technical University for Women, Delhi</td>
                <td className="align-middle"></td>
              </tr>
              <tr>
                <td className="align-middle">Dr. Ritu Rani</td>
                <td className="align-middle">Guru Gobind Singh Indraprastha University, Delhi</td>
                <td className="align-middle">ritujangra00@gmail.com</td>
              </tr>
              <tr>
                <td className="align-middle">Dr. Garima Jaiswal</td>
                <td className="align-middle">Bennett University, India</td>
                <td className="align-middle"></td>
              </tr>
            </tbody>
          </table>
          <br></br>
          <hr></hr> */}

          <h2 id="session1">SS1: Revolutionizing Finance: Time Series Analysis, Spatio-Temporal Forecasting, and Large-Scale Models</h2>
          <p className="home-p text-justify">

The financial industry is undergoing a profound transformation, driven by the rapid evolution of artificial intelligence (AI) and machine learning (ML) technologies. At the heart of this revolution are time series analysis, spatio-temporal forecasting, and large-scale models, which are redefining how financial data is interpreted, analyzed, and utilized. These methodologies leverage vast and diverse datasets—ranging from historical financial records and real-time market feeds to geospatial information and economic indicators—to provide a comprehensive and nuanced understanding of market dynamics. By integrating temporal and spatial dimensions, they enable financial institutions to uncover hidden patterns, predict future trends, and manage risks with unprecedented accuracy. This innovative approach is not only enhancing predictive capabilities but also driving advancements in critical areas such as portfolio management, asset allocation, fraud detection, and regulatory compliance. As financial markets grow increasingly complex and interconnected, the ability to process and analyze data in real-time, adapt to dynamic market conditions, and scale models to handle high-frequency, high-dimensional datasets has become essential. However, this technological leap also brings challenges, including ethical considerations such as data biases, transparency, and privacy concerns, as well as the need for robust regulatory frameworks to ensure responsible use. Looking ahead, emerging trends like quantum computing, generative AI, and blockchain are poised to further revolutionize financial forecasting, offering new possibilities for innovation and efficiency. The integration of time series analysis, spatio-temporal forecasting, and large-scale models represents a paradigm shift in the financial industry, empowering institutions to unlock new opportunities, enhance decision-making processes, and navigate the complexities of modern markets with confidence and precision.
            <br></br>
            <h4>Topics of Interest</h4>
            Topics of interest include, but are not limited to:
            <ul>
              <li>Advanced algorithms for financial time series and spatio-temporal forecasting</li>
              <li>Deep learning architectures (e.g., LSTMs, Transformers) for predictive modeling</li>
              <li>Integration of geospatial data with financial time series for regional insights</li>
              <li>Scalable architectures and transfer learning for large-scale financial models</li>
              <li>Real-time forecasting and adaptive modeling for dynamic market conditions</li>
              <li>Anomaly detection and outlier analysis for fraud detection and risk management</li>
              <li>Ethical considerations in financial forecasting, including bias and transparency</li>
              <li>Privacy-preserving techniques and compliance with data protection regulations</li>
              <li>Applications in portfolio optimization, asset allocation, and economic trend analysis</li>
              <li>Emerging trends: quantum computing, generative AI, and blockchain in finance</li>
            </ul>

            <h4>Submission</h4>
            Please follow the DMBD&apos;2025 instruction for authors and submit your paper via the DMBD&apos;2025
            online submission system. Please specify that your paper is for &quot;SS1: Revolutionizing Finance: Time Series Analysis, Spatio-Temporal Forecasting, and Large-Scale Models&quot; in your paper.
          </p>

          <h4>Organizers</h4>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Affiliate</th>
                <th scope="col">Email</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="align-middle">Prof. Ying Tan</td>
                <td className="align-middle">	Peking University</td>
                <td className="align-middle">ytan@pku.edu.cn</td>
              </tr>
              <tr>
                <td className="align-middle">Wenbo Yan</td>
                <td className="align-middle">	Peking University</td>
                <td className="align-middle">	wenboyan@stu.pku.edu.cn</td>
              </tr>

            </tbody>
          </table>
          <br></br>
          <hr></hr>

          
          <div className="call-sp">


            <h2 id="callforss">DMBD 2025 Call for Special Session Proposals</h2>
            <br></br>
            <p align="justify">
              DMBD 2025 technical program will include special sessions. Their aim is to provide a
              complementary flavor to the regular sessions and should include hot topics of interest
              to the data mining and big data community that may also go beyond disciplines traditionally
              represented at DMBD.
            </p>

            <p align="justify">
              Prospective organizers of special sessions should submit proposals indicating:
              <ul >
                <li>Title of the session.</li>
                <li>Rationale of the need for the special session at DMBD.</li>
                <li>The rationale should stress the novelty of the topic and/or its multidisciplinary
                  flavor, and must explain how it is different from the subjects covered by the
                  regular sessions.</li>
                <li>Short biography of the organizers.</li>
                <li>List of 5 – 6 contributed papers (including titles, authors, contact information of
                  the corresponding author) (this can also be provided later when they become
                  available).</li>
              </ul>
            </p>


            <p align="justify">
              Proposals are due on or before 	September 15th, 2025 and should be sent via e-mail (in
              either
              pdf
              or plain ASCII text form) to the special sessions chair (to be announced) and forward to
              DMBD 2025 secretariat at <a href="mailto: dmbd2025@iasei.org">dmbd2025@iasei.org</a>.
            </p>

            <p align="justify">

              Proposals will be evaluated based on the timeliness of the topic, the qualifications of
              the
              organizers and the authors of the papers proposed in the session. In its decision, the
              committee will try to realize a balance of the topics across the technical areas
              represented
              data mining and big data.

            </p>

            <p align="justify">
              Notification of acceptance will be sent to the organizers no later than September 20th, 2025,
              2025.
              Authors of papers included in approved special sessions should submit their manuscript
              on or  before September 31st, 2025. Manuscripts should conform to the formatting and electronic
              submission guidelines of regular DMBD papers (Springer’s CCIS format).
            </p>

            <p align="justify">
              When they submit papers, there is a choice to indicate that their papers are special
              session
              papers which will also undergo peer review. It is the responsibility of the organizers
              to
              ensure that their special session meets the DMBD quality standards. If, at the end of
              the
              review process, less than four papers are accepted, the session will be canceled and the
              accepted papers will be moved to regular sessions.
            </p>


          </div>

        </div>
      </EmptyTwo>
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
  }
  else {
    return (
      <React.Fragment>
      <SEO title="Special Sessions | DMBD 2025" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Special Sessions"
        content="For Authors"
        contentTwo="Special Sessions"
        linkage="/"

      />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div>
            <h4>To be released.</h4>
          </div>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    )
  }
};

export default SpecialSession;
